import { css } from "@compiled/react";
// @ts-expect-error is correct import
import { useInView } from "react-intersection-observer";

import { media } from "@atlaskit/primitives";
import { token } from "@atlaskit/tokens";

import ErrorBoundary from "@/components/error-boundary";
import { AnimateCount } from "@/libraries/design/patterns/stats/src/stats";

export interface UniformSingleStatProps {
    number: string;
    symbolCharacter?: string;
    description: string;
}

const UniformSingleStat = ({
    number,
    symbolCharacter,
    description
}: UniformSingleStatProps) => {
    const { ref: scrollRef, inView: sectionIsVisible } = useInView();

    return (
        <div css={statContainerStyles} ref={scrollRef}>
            <dt css={statInnerContainerStyles}>
                <span css={statNumberStyles}>
                    <ErrorBoundary fallback={null}>
                        {sectionIsVisible ? (
                            <AnimateCount>{number}</AnimateCount>
                        ) : (
                            number
                        )}
                    </ErrorBoundary>
                </span>
                {symbolCharacter && (
                    <span css={statSymbolCharacterStyles}>
                        {symbolCharacter}
                    </span>
                )}
            </dt>
            <dd css={statDescriptionStyles}>{description}</dd>
        </div>
    );
};

const statContainerStyles = css({
    maxWidth: "500px",
    display: "flex",
    flexDirection: "column",
    gap: token("space.050"),
    alignItems: "center",
    justifyContent: "center",
    fontFamily: token("font.family.code"),
    color: "var(--wac-color-heading)",
    [media.below.sm]: {
        gap: 0
    }
});

const statInnerContainerStyles = css({
    display: "flex",
    flexDirection: "row",
    gap: token("space.050"),
    alignItems: "end",
    fontWeight: 700,
    [media.below.sm]: {
        marginBlockEnd: "-16px"
    }
});

const statNumberStyles = css({
    fontSize: "128px",
    [media.below.sm]: {
        fontSize: "72px"
    }
});

const statSymbolCharacterStyles = css({
    fontSize: "96px",
    lineHeight: "146px",
    [media.below.sm]: {
        fontSize: "40px",
        lineHeight: "74px"
    }
});

const statDescriptionStyles = css({
    margin: 0,
    fontSize: "28px",
    fontWeight: 300,
    textAlign: "center",
    lineHeight: "40px",
    [media.below.sm]: {
        fontSize: "12px"
    }
});

export default UniformSingleStat;
